import { TextStyle } from '../../../../../types'
import { default as AlignType } from '../../../../../types/align'
import { DEFAULT_CAPTION_STYLE } from '../../../constants'
import Align from './align'
import Color from './color'
import Stroke from './stroke'
import { Font, Row } from './style'

type Props = {
    buttonColor?: string
    className?: string
    textStyle: TextStyle
    onChange?: (style: Partial<TextStyle>) => void
}

const UGECaptionsEditorTextStyle = ({ buttonColor, className, textStyle, onChange }: Props) => {
    const {
        align = DEFAULT_CAPTION_STYLE.align,
        color = DEFAULT_CAPTION_STYLE.color,
        fontFamily = DEFAULT_CAPTION_STYLE.fontFamily,
        strokeColor = DEFAULT_CAPTION_STYLE.strokeColor,
        strokeSize = DEFAULT_CAPTION_STYLE.strokeSize,
    } = textStyle

    function onAlignChange(newAlign: AlignType) {
        onChange?.({ align: newAlign })
    }

    function onColorChange(newColor: string) {
        onChange?.({ color: newColor })
    }

    function onFontChange(font: string) {
        onChange?.({ fontFamily: font })
    }

    function onStrokeColorChange(newColor: string) {
        onChange?.({ strokeColor: newColor })
    }

    function onStrokeSizeChange(size?: number) {
        onChange?.({ strokeSize: size })
    }

    return (
        <Row className={className}>
            <Font buttonColor={buttonColor} fontFamily={fontFamily} onChange={onFontChange} />
            <Color buttonColor={buttonColor} color={color} icon="fill" label="Fill Color" onChange={onColorChange} />
            <Stroke
                buttonColor={buttonColor}
                color={strokeColor}
                strokeSize={strokeSize}
                onColorChange={onStrokeColorChange}
                onSizeChange={onStrokeSizeChange}
            />
            <Align align={align} buttonColor={buttonColor} onChange={onAlignChange} />
        </Row>
    )
}

export default UGECaptionsEditorTextStyle
